export enum REGULARITY {
  ONETIME = 'onetime',
  WEEK = 'week',
  MONTH = 'month',
  HALF_YEAR = 'half-year',
  YEAR = 'year',
}

export interface ProductType {
  created_at: string;
  is_unlimited: boolean;
  currency: string;
  has_trial_period: boolean;
  id: string;
  is_solid: boolean;
  name: string;
  alternative_non_trial_name: string;
  solid_name_for_bi: string;
  price: number;
  subscription_type: string;
  trial_amount: number;
  trial_currency: string;
  trial_period: number;
  updated_at: string;
  regularity: REGULARITY;
  new_price_ui: number;
  old_price_ui: number;
  discount_percentage_ui: number;
  regularity_ui: REGULARITY;
  description_ui: string;
  details_ui: string;
  billing_period?: number;
  is_popular_ui: boolean;
  tags: string[];
}

export type SubscriptionTypeLabel =
  | 'trial'
  | 'monthly'
  | 'annual'
  | 'quarterly';

export const getSubscriptionType = (
  product: ProductType,
): SubscriptionTypeLabel => {
  if (product.has_trial_period) return 'trial';
  if (product.billing_period === 90) return 'quarterly';
  if (product.regularity === REGULARITY.YEAR) return 'annual';
  return 'monthly';
};

export enum LIMITED_TOOL {
  ai_content_detector = 'ai_content_detector',
  plagiarism_checker = 'plagiarism_checker',
  ai_text_humanizer = 'ai_text_humanizer',
}
